<template>
    <div id="sidebar" :class="isSidebarMenuOpen ? 'open' : openCount > 0 ? 'closed' : ''">
        <div class="sidebar-header">
            <div class="header-top">
                <img class="logo" src="@/assets/isologotipo_chatpts_transparente.svg" alt="Logo de ChatPTS"
                    @click="goToMainView">
                <button v-if="isMobile" class="close-sidebar-button" @click.self="closeSidebar">
                    <ion-icon name="close-outline"></ion-icon>
                </button>
            </div>
            <!-- <div class="platform-buttons" v-if="isAdmin"> -->
            <div class="platform-buttons">
                <button class="platform-button whatsapp-button" @click="goToWhatsApp">
                    <ion-icon name="logo-whatsapp" />WA
                </button>
                <button class="platform-button telegram-button" @click="goToTelegram">
                    <ion-icon name="send" />TG
                </button>
            </div>
            <button v-if="!modoRedaccion" class="new-conversation" @click="startNewConversation">
                <ion-icon name="create" />Nueva conversación
            </button>
            <button v-else class="new-conversation" @click="startNewConversation">
                <ion-icon name="create" />Nuevo proyecto de nota
            </button>
        </div>


        <div class="conversation-chips">
            <div class="row" v-if="modoRedaccion">
                <button class="proyectos mios" :class="proyectos === 'mios' ? 'selected' : ''"
                    @click="proyectos = 'mios'">Ver míos</button>
                <button class="proyectos todos" :class="proyectos === 'todos' ? 'selected' : ''"
                    @click="proyectos = 'todos'">Ver Todos</button>
                <select v-model="activeOption">
                    <option v-for="option in modosOptions" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
                </select>
            </div>
            <h1 v-if="modoRedaccion">Proyectos de nota</h1>
            <div class="scrollable-container">
                <div class="scrollable">
                    <template v-if="!modoRedaccion">
                        <ConversationChipComponent
                            @click="selectConversation(conversation.conversation_id, conversation.title)"
                            v-for="conversation in conversationsHistory" :key="conversation.id"
                            :conversationId="conversation.conversation_id" :conversationTitle="conversation.title"
                            :messagesNumber="conversation.message_count" :selected="conversation.newest" />
                    </template>
                    <template v-else>
                        <NotaChipComponent
                            @click="selectConversation(conversation._id, conversation.request.general_instructions, conversation.status === 'draft')"
                            v-for="conversation in conversationsHistory" :key="conversation.id"
                            :conversationId="conversation._id"
                            :title="conversation.title ? conversation.title : conversation._id"
                            :createdAt="conversation.created_at" :status="conversation.status"
                            :userId="conversation.user_id" :selected="conversation.newest" />
                    </template>

                    <div v-if="loadingConversationsHistory">
                        <h1>Cargando...</h1>
                    </div>
                    <button v-if="hasMore && !loadingConversationsHistory" class="load-more"
                        @click="getConversationsHistory">Cargar
                        más</button>
                    <div class="padding"><br /></div>
                </div>
            </div>
        </div>
        <div class="user-info" :class="{ 'admin-user': isAdmin }">
            <div class="user-avatar" @click="goToProfile">
                <img v-if="userProfilePicture" :src="userProfilePicture" alt="Foto de perfil">
                <div v-else class="default-avatar">{{ userInitials }}</div>
            </div>
            <div class="user-details" @click="goToProfile">
                <div class="user-name">{{ userName }}</div>
                <div class="user-email">{{ email }}</div>
            </div>
            <button class="logout-button" @click="logout">
                <ion-icon name="log-out"></ion-icon>
            </button>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import { COUNTRY } from '../utils/countryConfig';
axios.defaults.withCredentials = true;

import ConversationChipComponent from './ConversationChipComponent.vue';
import NotaChipComponent from './NotaChipComponent.vue';
import { modosOptions } from '@/utils/modosOptions';

export default {
    name: 'ConversationSidebarComponent',
    props: {
        email: {
            type: String,
            required: true,
        },
        conversation_id: {
            type: String,
            required: false,
            default: null,
        },
        is_new_conversation: {
            type: Boolean,
            required: true,
        },
        conversation_title: {
            type: String,
            required: false,
            default: null,
        },
        new_conversation_info: {
            type: Object,
            required: true,
        },
        isSidebarMenuOpen: {
            type: Boolean,
            required: true,
        },
        subscription: {
            type: Object,
            required: false,
            default: null,
        },
        modoRedaccion: {
            type: Boolean,
            required: false,
            default: false,
        },
        userProfilePicture: {
            type: String,
            required: false,
            default: null,
        },
        userName: {
            type: String,
            required: false,
            default: '',
        },
        permissions: {
            type: Array,
            required: false,
            default: () => []
        },
    },
    components: {
        ConversationChipComponent,
        NotaChipComponent,
    },
    computed: {
        userInitials() {
            if (!this.userName) return '?';
            return this.userName.split(' ')
                .map(name => name.charAt(0).toUpperCase())
                .slice(0, 2)
                .join('');
        },
        isAdmin() {
            return this.permissions && this.permissions.includes('admin:data');
        }
    },
    data() {
        return {
            modosOptions,
            activeOption: 'Nota',
            conversationsHistory: [],
            userId: this.email,  // Puedes ajustar esto según tu lógica de autenticación
            apiUrlConversations: process.env.VUE_APP_BASE_URL + '/api/v2/chat/get-user-conversations/',  // Ajusta la URL a tu endpoint
            apiUrlArticles: process.env.VUE_APP_BASE_URL + '/api/v2/redaccion/list/articles/',  // Ajusta la URL a tu endpoint
            loadingConversationsHistory: false,
            openCount: 0,
            offset: 0,
            limit: 10,
            hasMore: true,
            proyectos: 'mios',
            isMobile: false
        };
    },
    watch: {
        proyectos(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.conversationsHistory = [];
                this.offset = 0;
                this.hasMore = true;
                this.fetchLists();
            }
        },
        userId(newUserId) {
            this.getConversationsHistory(newUserId);
        },
        new_conversation_info(newConversationInfo) {
            if (newConversationInfo.conversation_id) {
                // Find the conversation in the list and set the title to the new one
                let found = false;
                this.conversationsHistory.forEach((conversation) => {
                    if (conversation.conversation_id === newConversationInfo.conversation_id) {
                        conversation.title = newConversationInfo.conversation_title;
                        conversation.message_count = 2;
                        conversation.newest = true;
                        found = true;
                    } else {
                        conversation.newest = false;
                    }
                });

                if (!found) {
                    this.conversationsHistory.unshift({
                        conversation_id: newConversationInfo.conversation_id,
                        title: newConversationInfo.conversation_title,
                        message_count: 2,
                        newest: true,
                    });
                }
            }
        },
        isSidebarMenuOpen(newVal) {
            if (newVal) {
                this.openCount++;
            }
        },
        activeOption() {
            // Empty the conversationsHistory array and reset the offset and hasMore
            this.conversationsHistory = [];
            this.offset = 0;
            this.hasMore = true;
            this.fetchLists();
        },
    },
    methods: {
        goSuscribirse() {
            this.$router.push({ name: "suscribirse" });
        },
        async getConversationsHistory() {
            if (this.loadingConversationsHistory || !this.hasMore) return;

            this.loadingConversationsHistory = true;

            let finalEndpoint = this.modoRedaccion ? this.apiUrlArticles : this.apiUrlConversations;
            if (this.proyectos === 'mios') {
                finalEndpoint += `?propios=${true}`;
            }

            try {
                // Make a request with the current offset and limit
                const response = await axios.get(finalEndpoint, {
                    params: {
                        offset: this.offset,
                        limit: this.limit,
                        country: COUNTRY
                    },
                });

                // Update conversations history with the new data
                if ((this.modoRedaccion && response.data.length > 0) || (!this.modoRedaccion && response.data.conversations && response.data.conversations.length > 0)) {
                    if (this.modoRedaccion) {
                        this.conversationsHistory.push(...response.data);
                    } else {
                        this.conversationsHistory.push(...response.data.conversations);
                        this.conversationsHistory.forEach(conversation => {
                            conversation.newest = conversation.conversation_id === this.conversation_id;
                        });
                    }
                    this.offset += this.limit; // Increment offset for the next batch

                    // If the number of conversations returned is less than the limit, assume there are no more to load
                    if ((this.modoRedaccion && response.data.length < this.limit) || (!this.modoRedaccion && response.data.conversations.length < this.limit)) {
                        this.hasMore = false;
                    }
                } else {
                    // If no conversations are returned, set hasMore to false
                    this.hasMore = false;
                }

                // // Select the first conversation if this is the initial load
                // if (this.conversationsHistory.length > 0 && this.offset === this.limit) {
                //     if (this.modoRedaccion) {
                //         this.selectConversation(
                //             this.conversationsHistory[0]._id,
                //             this.conversationsHistory[0].title
                //         );
                //     } else {
                //         this.selectConversation(
                //             this.conversationsHistory[0].conversation_id,
                //             this.conversationsHistory[0].title
                //         );
                //     }
                // }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    this.conversationsHistory = [];
                } else if (error.response && error.response.status === 401) {
                    // emit logout event
                    this.$emit('logout');
                    this.$router.push({ name: 'main-view' });
                    this.showToast("Sesión expirada o inválida - por favor, volvé a ingresar", "warning");
                } else if (error.response && error.response.status === 426) {
                    this.showModal = true;
                    this.showToast(error.response.data.detail, "error");
                } else if (error.response && (error.response.status === 400 || error.response.status === 429)) {
                    const message = error.response.data.detail;
                    this.showToast("ERROR: " + message, "error");
                } else if (error.response && (error.response.status === 409)) {
                    const message = error.response.data.detail;
                    this.showToast("ERROR: " + message, "error");
                } else {
                    console.error('Error al obtener el historial de chat:', error);
                    this.showToast("¡Estamos con mucha demanda! Intenta nuevamente.", "error");
                }
            }



            this.loadingConversationsHistory = false;
        },
        async fetchLists() {
            const selectedModo = this.modosOptions.find(option => option.value === this.activeOption);
            if (!selectedModo || !selectedModo.endpoint) return;

            this.loadingConversationsHistory = true;

            let finalEndpoint = `${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/list/${selectedModo.endpoint}/`
            if (this.proyectos === 'mios') {
                finalEndpoint += `?propios=${true}`;
            }

            try {
                const response = await axios.get(finalEndpoint, {
                    params: {
                        offset: this.offset,
                        limit: this.limit,
                        country: COUNTRY
                    },
                });
                // Update conversationsHistory with the fetched data
                this.conversationsHistory = response.data;

                // Select the first conversation if this is the initial load
                if (this.conversationsHistory.length > 0 && this.offset === 0) {
                    if (this.modoRedaccion) {
                        this.selectConversation(
                            this.conversationsHistory[0]._id,
                            this.conversationsHistory[0].title
                        );
                        console.log("SELECTING FIRST this.conversationsHistory[0]._id", this.conversationsHistory[0]._id);
                    } else {
                        this.selectConversation(
                            this.conversationsHistory[0].conversation_id,
                            this.conversationsHistory[0].title
                        );
                    }
                }

                // Update offset and hasMore if necessary
                this.offset += this.limit;
                if (response.data.length < this.limit) {
                    this.hasMore = false;
                }
            } catch (error) {
                console.error('Error fetching list:', error);
                this.showToast('Error fetching list', 'error');
            }
            this.loadingConversationsHistory = false;
        },
        selectConversation(conversationId, conversationTitle, is_new = false) {
            // find the conversation in the list and mark it as selected with newest = true and set the rest to false
            this.conversationsHistory.forEach((conversation) => {
                conversation.newest = this.modoRedaccion ? conversation._id == conversationId : conversation.conversation_id === conversationId;
            });

            this.$emit('conversation-selected', conversationId, conversationTitle, is_new, !is_new ? this.activeOption : '');
        },
        startNewConversation() {
            // generate a uuid with format 556e919b-eb4d-4eff-9c6e-4d39b287bd7e
            let conversation_id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });

            let mew_conversation = {
                conversation_id: conversation_id,
                title: 'Nueva conversación',
                message_count: 0,
                newest: true,
            };

            let new_article = {
                _id: conversation_id,
                title: 'Nuevo proyecto de nota',
                request: {
                    general_instructions: 'Escribe aquí las instrucciones generales para el proyecto de nota',
                },
                created_at: new Date().toISOString(),
                status: 'draft',
                user_id: this.userId,
                newest: true,
            }

            // add the new conversation to the list in the first position
            this.conversationsHistory.unshift(this.modoRedaccion ? new_article : mew_conversation);

            this.selectConversation(conversation_id, this.modoRedaccion ? 'Nuevo proyecto de nota' : 'Nueva conversación', true);
        },
        showToast(message, type) {
            this.$emit('show-toast', message, type);
        },
        goToPublicQuestions() {
            this.$router.push({ name: 'public-questions' });
        },
        goToMainView() {
            this.$router.push({ name: "main-view" });
        },
        goToProfile() {
            this.$router.push({
                name: "perfil",
                params: {},
                query: {}
            });
        },
        goToWhatsApp() {
            this.$router.push({
                name: "perfil",
                params: {},
                query: {},
                hash: "#whatsapp"
            });
        },
        goToTelegram() {
            this.$router.push({
                name: "perfil",
                params: {},
                query: {},
                hash: "#telegram"
            });
        },
        logout() {
            this.$emit('logout');
        },
        closeSidebar() {
            let parent = this.$parent;
            while (parent && !('isSidebarMenuOpen' in parent.$data)) {
                parent = parent.$parent;
            }

            if (parent && 'isSidebarMenuOpen' in parent.$data) {
                parent.isSidebarMenuOpen = false;
            } else {
                this.$parent.$emit('toggle-sidebar');
            }
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        }

    },
    async mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const agenteParam = urlParams.get('agente');
        if (agenteParam) {
            switch (agenteParam) {
                case 'article':
                    this.activeOption = 'Nota';
                    break;
                case 'reinterpretation':
                    this.activeOption = 'Reinterpretar';
                    break;
                case 'editorial':
                    this.activeOption = 'Editorial';
                    break;
                case 'placas':
                    this.activeOption = 'Placas';
                    break;
                case 'thread':
                    this.activeOption = 'Twitter';
                    break;
                case 'script':
                    this.activeOption = 'Guion';
                    break;
                case 'titles':
                    this.activeOption = 'Títulos';
                    break;
                case 'correction':
                    this.activeOption = 'Corrector';
                    break;
                default:
                    this.activeOption = 'Nota';
                    break;
            }
        }
        if (this.activeOption === 'Nota') {
            await this.getConversationsHistory();
        }

        // Check if device is mobile
        this.checkMobile();

        // Add resize event listener
        window.addEventListener('resize', this.checkMobile);
    },
    beforeUnmount() {
        // Remove resize event listener
        window.removeEventListener('resize', this.checkMobile);

        // Remove scroll event listener to avoid memory leaks
        const container = this.$refs.scrollContainer;
        if (container) {
            container.removeEventListener('scroll', this.handleScroll);
        }
    }
};
</script>

<style scoped>
#sidebar {
    max-width: 400px;
    height: 100vh;
    background-color: rgba(230, 230, 230, 0.9);
    /* background-color: #ffffff; */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    color: #333333;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 0;
    flex-shrink: 0;
    overflow: hidden;
}

.sidebar-header {
    width: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.header-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.close-sidebar-button {
    background: none;
    border: none;
    color: #333;
    font-size: 24px;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 12px;
    right: 12px;
}

.logo {
    max-width: 175px;
    margin-bottom: 0;
    padding-top: 12px;
    cursor: pointer;
    align-self: center;
    margin-top: 12px;
    margin-left: auto;
    margin-right: auto;
}

.scrollable-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
}

.scrollable {
    overflow-y: auto;
    margin-right: 12px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

h1 {
    text-align: left;
    color: #333;
    padding: 20px 0;
    padding-left: 24px;
    align-self: center;
    font-size: 12pt;
    text-transform: uppercase;
    /* Rojo principal */
}

.conversation-chips {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 12px;
    width: 100%;
    flex: 1;
    overflow: hidden;
}

.new-conversation {
    border: none;
    background-color: #a1344e;
    color: #ffffff;
    border-radius: 4px;
    padding: 12px 16px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    transition: all .2s ease-in-out;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.new-conversation ion-icon {
    margin-right: 8px;
    font-size: 18px;
}

.new-conversation:hover {
    background-color: #b71c1c;
}

.platform-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-bottom: 12px;
}

.platform-button {
    border: 1px solid rgba(161, 52, 78, 0.3);
    background-color: transparent;
    color: #333333;
    border-radius: 4px;
    padding: 10px 14px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    transition: all .2s ease-in-out;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: none;
}

.platform-button ion-icon {
    margin-right: 8px;
    font-size: 16px;
}

.whatsapp-button:hover {
    background-color: #25D366;
    color: white;
    border-color: #25D366;
}

.telegram-button:hover {
    background-color: #0088cc;
    color: white;
    border-color: #0088cc;
}

.platform-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.public-questions {
    border: none;
    color: #ffffff;
    text-decoration: underline;
    background-color: transparent;
    border-radius: 4px;
    padding: 16px;
    cursor: pointer;
    font-size: 12pt;
    margin-bottom: 36px;
    align-self: center;
    font-weight: bold;
    transition: all .2s ease-in-out;
}

.suscribirse {
    display: none;
}

.load-more {
    border: none;
    background-color: #a1344e;
    color: #ffffff;
    border-radius: 4px;
    padding: 16px;
    cursor: pointer;
    font-size: 12pt;
    margin-bottom: 12px;
    align-self: center;
    font-weight: bold;
    text-transform: uppercase;
    transition: all .2s ease-in-out;
    margin-top: 20px;
}

#sidebar select {
    background-color: #a1344e;
    color: #ffffff;
    border: none;
    padding: 12px;
    margin-bottom: 12px;
    align-self: center;
    font-size: 12pt;
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 6px;
}

.conversation-chips .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 12px;
}

.conversation-chips .row button {
    border: none;
    background-color: transparent;
    color: #ffffff;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 12pt;
    margin-bottom: 12px;
    align-self: center;
    font-weight: bold;
    text-transform: uppercase;
    transition: all .2s ease-in-out;
    margin-right: 12px;
    transition: all .2s ease-in-out;
    font-weight: 400;
}

.conversation-chips .row button.selected {
    background-color: #a1344e;
    color: #ffffff;
    font-weight: 600;
}

.conversation-chips .row button:hover {
    background-color: #642131;
    color: #ffffff;
}

.user-info {
    width: 100%;
    padding: 15px;
    display: flex;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    margin-top: auto;
    background-color: #a1344e;
}

.user-info.admin-user {
    background-color: #d4af37;
    /* Gold color for admins */
    color: #333;
    /* Darker text for better contrast on gold */
}

.user-info.admin-user .user-email {
    color: #555;
}

.user-info.admin-user .logout-button {
    color: #333;
}

.user-info.admin-user .logout-button:hover {
    color: #000;
}

.user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
    flex-shrink: 0;
    cursor: pointer;
}

.user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.default-avatar {
    width: 100%;
    height: 100%;
    background-color: #a1344e;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
}

.user-details {
    flex-grow: 1;
    overflow: hidden;
    cursor: pointer;
    color: #f0f0f0;
}

.user-info.admin-user .user-details {
    color: #333;
}

.user-name {
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user-email {
    font-size: 12px;
    opacity: 0.8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.logout-button {
    background: none;
    border: none;
    color: #f0f0f0;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    padding: 5px;
    margin-left: 10px;
}

.logout-button:hover {
    color: #333;
}


/* Slide left-in animation */
@keyframes slideInLeft {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes slideOutLeft {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-100%);
    }

}


.contactanos {
    color: #ffffff;
}


@media screen and (max-width: 1100px) {
    .logo {
        max-width: 110px;
        padding-top: 0;
    }

    .conversation-title {
        font-size: 11pt;
    }
}

@media screen and (max-width: 768px) {
    #sidebar {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        transition: display 0.3s ease-in-out;
        box-shadow: 5px 0 10px 1px rgba(0, 0, 0, 0.3);
        border-radius: 0;
        align-items: flex-start;
        padding: 12px 0 0 0;
        max-width: 90vw;
        min-width: 80%;
        background-color: rgba(230, 230, 230, 1);
        transform: translateX(-100%);
        height: 100vh;
        height: 100dvh;
    }

    .new-conversation {
        margin: 0;
        margin-bottom: 12px;
    }

    h1 {
        align-self: flex-start;
        font-size: 16pt;
        margin-top: 0;
        padding-top: 0;
        padding-left: 24px;
    }

    #sidebar.open {
        display: flex;
        animation: slideInLeft 0.3s ease-in-out forwards;
    }

    #sidebar.closed {
        animation: slideOutLeft 0.3s ease-in-out forwards;
    }

    .conversation-chips {
        margin-top: 0;
        height: calc(100% - 49px);
    }

    .scrollable-container {
        margin-top: 0px;
    }

    .conversation-chip.selected {
        font-size: 13pt;

    }

    .conversation-title {
        font-size: 12pt;
    }

    .suscribirse {
        display: block;
        background-color: #a1344e;
        border: none;
        color: #f0f0f0;
        font-size: 14pt;
        padding: 12px;
        margin-bottom: 24px;
        align-self: center;
        margin-right: 24px;
    }

    .public-questions {
        margin-bottom: 12px;
    }

    .scrollable {
        height: 98%;
    }

    .navbar-footer {
        padding-left: 24px;
    }

    .logo {
        max-width: 150px;
        padding-top: 0;
        margin-bottom: 24px;
    }
}

@media screen and (max-width: 480px) {
    .logo {
        max-width: 110px;
        padding-top: 0;
        margin-bottom: 24px;
    }
}
</style>
